import { Action, Dispatch } from "redux";
import { IOrganizationData } from "../CustomTypes";
import checkError from "./checkError";
import { actionTypes, apiStatuses, FetchBrregInfo } from "./Actions";

const fetchBrregInfo: FetchBrregInfo = (orgnumber: string) => (
  dispatch: Dispatch<Action>
) => {
  dispatch({
    status: apiStatuses.LOADING,
    type: actionTypes.FETCH_BRREG_INFO
  });
  dispatch({
    data: {} as IOrganizationData,
    type: actionTypes.SET_BRREG_INFO
  });
  fetch(`https://data.brreg.no/enhetsregisteret/api/enheter/${orgnumber}`)
    .then(result => checkError(result))
    .then(res => res.json())
    .then(data => {
      dispatch({
        data,
        status: apiStatuses.SUCCESS,
        type: actionTypes.SET_BRREG_INFO
      });
    });
};

export default fetchBrregInfo;
